import { NumberField, OrmModel, PrimaryKey, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { ProgressType } from '@/services/types'

@OrmModel(modelNames.PROGRESS)
export default class Progress extends BaseModel {
  @PrimaryKey()
  @StringField()
  public id: string // <type>-<id>

  @StringField()
  public type: ProgressType

  @StringField()
  public originalId: string

  @NumberField(0)
  public progress: number
}
